import Constants from "./constants";
import { Countries } from "./Countries";
import StringUtils from "./StringUtils";

export default class LocationUtil {
   static getCountryLocationOrDefault(countryName){
      if(StringUtils.isBlank(countryName)){
         return Constants.POLAND_LOCATION;
      }
      const foundedCountry = Countries.find(c => c.name.toLowerCase() === countryName.toLowerCase());
      if(foundedCountry){
         return foundedCountry.coords;
      }
      return Constants.POLAND_LOCATION;
   }

   static getCountryLocation(countryName){
      const foundedCountry = Countries.find(c => c.name.toLowerCase() === countryName.toLowerCase());
      if(foundedCountry){
            return foundedCountry.coords;
      }
      return null;
   }
}